import {
  useDeviceDefinitions,
  useDiagnosticDefinitions,
  useExamDefinitions,
  useTreatmentDefinitions,
} from "@repo/data-store";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { ProtocolDefinitionEdit } from "@/features/catalog";
import { protocolDefinitionRouteId } from "@/features/catalog/lib/protocol-definition-route";

export const Route = createFileRoute("/catalog/protocols/new")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canWrite("PlanDefinition")) throw redirect({ to: "/catalog/procedures" });
  },
  component: NewProtocol,
});

function NewProtocol() {
  const navigate = useNavigate();
  const treatments = useTreatmentDefinitions({ availability: "Active" });
  const diagnostics = useDiagnosticDefinitions({ availability: "Active" });
  const examDefinitions = useExamDefinitions({ availability: "Active" });
  // Unfiltered: a device requirement is unpinned, so a procedure may name a kind
  // that has since been deactivated and its parameters still need answering.
  const deviceDefinitions = useDeviceDefinitions();
  return (
    <ProtocolDefinitionEdit
      procedureItems={treatments}
      diagnosticItems={diagnostics}
      examItems={examDefinitions}
      deviceDefinitionItems={deviceDefinitions}
      canEdit
      onDone={(url) =>
        url
          ? navigate({ to: "/catalog/protocols/$protocolId", params: { protocolId: protocolDefinitionRouteId(url) } })
          : navigate({ to: "/catalog/procedures" })
      }
      onCancel={() => navigate({ to: "/catalog/procedures" })}
    />
  );
}
